import api, { unwrap } from './client';

import type { ApiResponse } from '@/types/api';

import type { SessionInitResponse } from '@/types/session';



type InitInflight = {

  key: string;

  promise: Promise<SessionInitResponse>;

};



let inflightInit: InitInflight | null = null;



function initRequestKey(companyId?: number, refresh = false): string {

  return `${companyId ?? ''}:${refresh}`;

}



export function clearInflightSessionInit(): void {
  inflightInit = null;
}

function requestInit(
  companyId?: number,
  options?: { refresh?: boolean; force?: boolean },
): Promise<SessionInitResponse> {
  const refresh = options?.refresh === true;
  const force = options?.force === true;
  const key = initRequestKey(companyId, refresh);

  if (!refresh && !force && inflightInit?.key === key) {
    return inflightInit.promise;
  }



  const promise = unwrap(

    api.get<ApiResponse<SessionInitResponse>>('/v1/session/init', {

      params: {

        ...(companyId != null ? { companyId } : {}),

        ...(refresh ? { refresh: true } : {}),

      },

    }),

  ).finally(() => {

    if (inflightInit?.key === key && inflightInit.promise === promise) {

      inflightInit = null;

    }

  });



  inflightInit = { key, promise };

  return promise;

}



export const sessionApi = {
  init: (companyId?: number, options?: { refresh?: boolean; force?: boolean }) =>
    requestInit(companyId, options),



  refresh: (companyId?: number) =>

    unwrap(

      api.post<ApiResponse<SessionInitResponse>>('/v1/session/init/refresh', null, {

        params: companyId != null ? { companyId } : undefined,

      }),

    ),

};

